import { Injectable, inject } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import type { NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { NiceAsyncTypeaheadProvider } from "@recursyve/nice-ui-kit.v2";
import type { Observable } from "rxjs";
import { lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { PrimarySystemMaterialsApi } from "../apis/enums/primary-system-materials.api";
import type { PrimarySystemMaterials } from "../models/enums/primary-system-materials.model";

@Injectable()
export class PrimarySystemMaterialsTypeaheadApi extends NiceAsyncTypeaheadProvider<PrimarySystemMaterials> {
    private readonly api = inject(PrimarySystemMaterialsApi);

    private readonly pageSize = 20;
    public readonly resource = "primarySystemMaterials";

    public override async getById(id: number): Promise<PrimarySystemMaterials> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PrimarySystemMaterials>> {
        return this.api
            .search({
                page,
                pageSize: this.pageSize,
                searchQuery
            })
            .pipe(
                map(items => ({
                    items,
                    nextPage: items.length === this.pageSize ? page + 1 : null
                }))
            );
    }

    public override format(primarySystemMaterial: PrimarySystemMaterials): string {
        if (!isPropertyDefined(primarySystemMaterial, "value")) {
            return "";
        }

        if (typeof primarySystemMaterial.value !== "string") {
            return "";
        }

        return primarySystemMaterial.value;
    }
}
